import { render, staticRenderFns } from "./AuthoriseXero.vue?vue&type=template&id=f9cba8fa"
import script from "./AuthoriseXero.vue?vue&type=script&lang=js"
export * from "./AuthoriseXero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports